import type { Observable } from 'rxjs';
import { iif, mergeMap, of } from 'rxjs';
import type { EAppMode, ELanguages } from '@common/enums';

import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import AppActions from './app.actions';
import * as AppSelectors from './app.selectors';

@Injectable()
export class AppFacade {
    private readonly store = inject(Store);

    public readonly isReady$: Observable<boolean> = this.store.select(AppSelectors.selectIsReady);
    public readonly isAdmin$: Observable<boolean> = this.store.select(AppSelectors.selectIsAdmin);
    public readonly mode$: Observable<EAppMode> = this.store.select(AppSelectors.selectMode);
    public readonly isEcommerceMode$: Observable<boolean> = this.store.select(AppSelectors.selectIsEcommerceMode);
    public readonly isEcommerceModeShallow$: Observable<boolean> = this.store.select(
        AppSelectors.selectIsEcommerceModeShallow
    );
    public readonly locale$: Observable<ELanguages> = this.store.select(AppSelectors.selectLocale);
    public readonly isMacOS$: Observable<boolean> = this.store.select(AppSelectors.selectIsMacOS);
    public readonly dataLayer$: Observable<any> = this.store.select(AppSelectors.selectDataLayer);

    public init(): void {
        this.store.dispatch(AppActions.initApp());
    }

    public setIsAdmin(isAdmin: boolean): void {
        this.store.dispatch(AppActions.setIsAdmin({ isAdmin }));
    }

    public setMode(mode: EAppMode): void {
        this.store.dispatch(AppActions.setMode({ mode }));
    }

    public isAdminCollectionWrapper$<T>(collectionObservable$: Observable<T>, defaultValue: any = []): Observable<T> {
        return this.isAdmin$.pipe(
            mergeMap((isAdmin: boolean) => iif(() => isAdmin, of(defaultValue), collectionObservable$))
        );
    }

    public exit(isRedirectTabClose: boolean = false): void {
        this.store.dispatch(AppActions.initExit({ isRedirectTabClose }));
    }

    public initNewPage(): void {
        this.store.dispatch(AppActions.initNewPage());
    }

    public updateSession(): void {
        this.store.dispatch(AppActions.updateSession());
    }

    public getDataLayer(): void {
        this.store.dispatch(AppActions.dataLayerRequest());
    }
}
